import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_left_nav = _resolveComponent("app-left-nav")!
  const _component_app_bottom_nav = _resolveComponent("app-bottom-nav")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_app_top_nav = _resolveComponent("app-top-nav")!
  const _component_UserFilled = _resolveComponent("UserFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_AccPageHeader = _resolveComponent("AccPageHeader")!
  const _component_app_user_top_profile = _resolveComponent("app-user-top-profile")!
  const _component_app_user_section = _resolveComponent("app-user-section")!
  const _component_app_user_skills = _resolveComponent("app-user-skills")!
  const _component_app_user_education = _resolveComponent("app-user-education")!
  const _component_app_user_experience = _resolveComponent("app-user-experience")!
  const _component_app_user_standardtests = _resolveComponent("app-user-standardtests")!
  const _component_AccPageRightNav = _resolveComponent("AccPageRightNav")!
  const _component_app_right_nav = _resolveComponent("app-right-nav")!
  const _component_app_main_layout = _resolveComponent("app-main-layout")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_app_main_layout, null, {
    left: _withCtx(() => [
      _createVNode(_component_app_left_nav)
    ]),
    "bottom-nav": _withCtx(() => [
      _createVNode(_component_app_bottom_nav)
    ]),
    top: _withCtx(() => [
      _createVNode(_component_app_top_nav, { padded: false }, {
        left: _withCtx(() => [
          false
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "text",
                plain: "",
                circle: "",
                "is-all-borderless": "",
                icon: "el-icon-back"
              }))
            : _createCommentVNode("", true)
        ]),
        center: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createElementVNode("span", { "nav-title": "" }, "Account Profile", -1)
        ]))]),
        right: _withCtx(() => [...(_cache[1] || (_cache[1] = []))]),
        bottom: _withCtx(() => [...(_cache[2] || (_cache[2] = []))]),
        _: 1
      })
    ]),
    middle: _withCtx(() => [
      (_ctx.user)
        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_AccPageHeader, null, {
              icon: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_UserFilled, { primary: "" })
                  ]),
                  _: 1
                })
              ]),
              content: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createElementVNode("span", null, " Customize how your profile looks like for other E4T users ", -1)
              ]))]),
              _: 1
            }),
            _cache[4] || (_cache[4] = _createElementVNode("div", { "App-User-Profile-Top": "" }, null, -1)),
            _createVNode(_component_app_user_section, { style: {"border-top-left-radius":"0px !important","border-top-right-radius":"0px !important"} }, {
              default: _withCtx(() => [
                _createVNode(_component_app_user_top_profile, {
                  isSelf: _ctx.isSelf,
                  user: _ctx.user
                }, null, 8, ["isSelf", "user"])
              ]),
              _: 1
            }),
            _createVNode(_component_app_user_skills, {
              isSelf: _ctx.isSelf,
              user: _ctx.user
            }, null, 8, ["isSelf", "user"]),
            _createVNode(_component_app_user_section, null, {
              default: _withCtx(() => [
                _createVNode(_component_app_user_education, {
                  isSelf: _ctx.isSelf,
                  user: _ctx.user
                }, null, 8, ["isSelf", "user"]),
                (_ctx.isTalent)
                  ? (_openBlock(), _createBlock(_component_app_user_experience, {
                      key: 0,
                      isSelf: _ctx.isSelf,
                      user: _ctx.user
                    }, null, 8, ["isSelf", "user"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_app_user_section, null, {
              default: _withCtx(() => [
                _createVNode(_component_app_user_standardtests, {
                  isSelf: _ctx.isSelf,
                  user: _ctx.user
                }, null, 8, ["isSelf", "user"])
              ]),
              _: 1
            })
          ])), [
            [_directive_loading, _ctx.loading]
          ])
        : _createCommentVNode("", true)
    ]),
    right: _withCtx(() => [
      _createVNode(_component_app_right_nav, null, {
        default: _withCtx(() => [
          _createVNode(_component_AccPageRightNav)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}